<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="a" itemtype="" style="width: 100px">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge class="item">
              <span style="width: 100px">全部</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="未入库" name="b" itemtype="0">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status0" class="item">
              <span>未入库</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已入库" name="c">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status1" class="item">
              <span>已入库</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待审核" name="d">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status2" class="item">
              <span>待审核</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="税金待支付" name="n">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status13" class="item">
              <span>税金待支付</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待打包" name="e">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status3" class="item">
              <span>待打包</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待发货" name="f">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status4" class="item">
              <span>待发货</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待支付" name="g">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status5" class="item">
              <span>待支付</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="转运中" name="h">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status6" class="item">
              <span>转运中</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已签收" name="i">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status7" class="item">
              <span>已签收</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="暂存" name="j">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status10" class="item">
              <span>暂存中</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已拒绝" name="k">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status8" class="item">
              <span>已拒绝</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="退款中" name="l">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status11" class="item">
              <span>退款中</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已退款" name="m">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status12" class="item">
              <span>已退款</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
    <!-- 搜索部分 -->
    <div class="table-container">
      <vab-query-form style="margin: 0">
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <!-- 订单编号 -->
          <el-form-item>
            <el-input v-model.trim="queryForm.code" placeholder="请输入订单编号" clearable />
          </el-form-item>
          <!-- 用户编号 -->
          <el-form-item>
            <el-input v-model.trim="queryForm.user_code" placeholder="请输入用户编号" clearable />
          </el-form-item>
          <!-- 运单号 -->
          <el-form-item>
            <el-input v-model.trim="queryForm.express_code" placeholder="请输入运单号" clearable />
          </el-form-item>
          <!-- 打印状态 -->
          <el-form-item>
            <el-select v-model="queryForm.print" clearable placeholder="打印状态" @keyup.enter.native="handleQuery">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 完善方式 -->
          <el-form-item>
            <el-select v-model="queryForm.shipping_type" clearable placeholder="完善方式" multiple
              @keyup.enter.native="handleQuery">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 开始日期 -->
          <el-form-item label="">
            <el-date-picker v-model="queryForm.time" @change="time_change" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <!-- 查询 -->
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
              查询
            </el-button>
          </el-form-item>
          <!-- 包裹库位移动 -->
          <el-form-item v-if="activeName == 'a' && !isPhone">
            <el-button type="warning" native-type="submit" @click="locaTionMove">
              包裹库位移动
            </el-button>
          </el-form-item>
          <!-- 包裹库位入库 -->
          <el-form-item v-if="activeName == 'a' && !isPhone">
            <el-button type="success" native-type="submit" @click="packageLocationInbound">
              包裹库位入库
            </el-button>
          </el-form-item>
          <!-- 添加包裹 -->
          <el-form-item v-if="!isPhone">
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
              添加包裹
            </el-button>
          </el-form-item>
          <!-- 批量删除 -->
          <el-form-item v-if="!isPhone">
            <el-button icon="el-icon-delete" type="danger" @click="handleDelete">
              批量删除
            </el-button>
          </el-form-item>
          <!-- 条件导出 -->
          <el-form-item v-if="!isPhone">
            <el-button type="primary" @click="exportForm1()">条件导出</el-button>
          </el-form-item>
          <!-- 批量导出 -->
          <el-form-item v-if="!isPhone">
            <el-button type="primary" @click="exportForm()">批量导出</el-button>
          </el-form-item>
          <!-- 导出发货信息 -->
          <el-form-item v-if="!isPhone && activeName != 'b' && activeName != 'c' && activeName != 'd'">
            <el-button type="primary" @click="exportForm2()">
              导出发货信息
            </el-button>
          </el-form-item>
          <!-- 批量审核通过 -->
          <el-form-item v-if="isShowDabao && !isPhone">
            <el-button type="primary" @click="setQuery(3)">
              批量审核通过
            </el-button>
          </el-form-item>
          <!-- 批量发货 -->
          <el-form-item v-if="isShowFahuo && !isPhone">
            <el-button type="primary" @click="setQuery(4)">
              批量发货
            </el-button>
          </el-form-item>
          <!-- 批量签收 -->
          <el-form-item v-if="isShowQianshou && !isPhone">
            <el-button type="primary" @click="setQuery(7)">
              批量签收
            </el-button>
          </el-form-item>
          <!-- 批量审核拒绝 -->
          <el-form-item v-if="isShowDabao && !isPhone">
            <el-button type="primary" @click="setQuery(8)">
              批量审核拒绝
            </el-button>
          </el-form-item>
          <!-- 完善导入 -->
          <el-form-item v-if="activeName == 'c' && !isPhone">
            <el-upload class="upload-demo" action="#" :http-request="exportForm3" :multiple="false"
              :show-file-list="false">
              <el-button :loading="exportForm3Loading" size="small" type="primary">
                完善导入
              </el-button>
            </el-upload>
          </el-form-item>
          <!-- 顺丰海运面单打印 -->
          <el-form-item v-if="!isPhone && activeName != 'b' && activeName != 'c' && activeName != 'd'">
            <el-button :loading="doSFHPrintLoading" type="primary" @click="get_size(0, 'SFH')">
              面单打印
            </el-button>
          </el-form-item>
          <!-- 顺丰海运面单打印预览 -->
          <el-form-item v-if="!isPhone && activeName != 'b' && activeName != 'c' && activeName != 'd'">
            <el-button :loading="SFHdoPreviewLoading" type="primary" @click="get_size(1, 'SFH')">
              面单预览
            </el-button>
          </el-form-item>
          <!-- 顺丰海运批量拉单 -->
          <el-form-item v-if="pullFormBtn && !isPhone">
            <el-button type="primary" @click="pullForm(4)">
              批量拉单
            </el-button>
          </el-form-item>
          <!-- 扫描包裹 -->
          <el-form-item v-if="pullFormBtn && !isPhone">
            <el-button type="success" @click="scanShow()">
              扫描包裹
            </el-button>
          </el-form-item>
          <!-- 打印包裹详情 -->
          <el-form-item v-if="!isPhone">
            <el-button type="primary" @click="printDetail()">
              打印包裹详情
            </el-button>
          </el-form-item>
          <!-- 打印拣货单 -->
          <el-form-item v-if="!isPhone && activeName != 'b' && activeName != 'c' && activeName != 'd'">
            <el-button :loading="doSFHPrintLoading" type="primary" @click="printPickingList()">
              打印拣货单
            </el-button>
          </el-form-item>



        </el-form>
      </vab-query-form>
      <el-table v-if="!isPhone" ref="tableSort" v-loading="listLoading" :data="list"
        :element-loading-text="elementLoadingText" :height="height" style="width: 100%" border
        @selection-change="setSelectRows" @sort-change="tableSortChange">
        <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
        <!-- 昵称 -->
        <el-table-column show-overflow-tooltip prop="user_name" label="用户昵称"></el-table-column>
        <!-- 用户编号 -->
        <el-table-column show-overflow-tooltip prop="user_code" label="用户编号" width="100"></el-table-column>
        <!-- 包裹类型 -->
        <el-table-column label="包裹类型" width="100">
          <template #default="{ row }">
            <span v-if="row.is_buy == 0">普通包裹</span>
            <span v-if="row.is_buy == 1">代买包裹</span>
          </template>
        </el-table-column>
        <!-- 商品图片 -->
        <el-table-column show-overflow-tooltip label="包裹图片">
          <template #default="{ row }">
            <el-image :preview-src-list="imageList" :src="row.pic"></el-image>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="发货方式" width="110">
          <template #default="{ row }">
            <span v-if="row.pulling_type == 1">圆通快递</span>
            <span v-if="row.pulling_type == 2">京东快递</span>
            <span v-if="row.pulling_type == 3">顺丰空运快递</span>
            <span v-if="row.pulling_type == 4">顺丰海运快递</span>
          </template>
        </el-table-column>
        <!-- 订单编号 -->
        <el-table-column show-overflow-tooltip prop="code" label="订单编号" width="350"></el-table-column>
        <!-- 运单号 -->
        <el-table-column show-overflow-tooltip prop="express_code" label="运单编号" width="200"></el-table-column>
        <!-- 包裹状态 -->
        <el-table-column label="状态" align="center" width="100">
          <template #default="{ row }">
            <el-tag v-if="row.status == 0" size="small" type="danger">
              未入库
            </el-tag>
            <el-tag v-if="row.status == 1" size="small" type="success">
              已入库
            </el-tag>
            <el-tag v-if="row.status == 2" size="small" type="warning">
              待审核
            </el-tag>
            <el-tag v-if="row.status == 13" size="small" type="primary">
              税金待支付
            </el-tag>
            <el-tag v-if="row.status == 3" size="small" class="dabaoStyle">
              待打包
            </el-tag>
            <el-tag v-if="row.status == 4" size="small" class="fahuoStyle">
              待发货
            </el-tag>
            <el-tag v-if="row.status == 5" size="small" type="warning">
              待支付
            </el-tag>
            <el-tag v-if="row.status == 6" size="small" class="zhuanyunStyle">
              转运中
            </el-tag>
            <el-tag v-if="row.status == 7" size="small" type="success">
              已签收
            </el-tag>
            <el-tag v-if="row.status == 8" size="small" type="danger">
              已拒绝
            </el-tag>
            <el-tag v-if="row.status == 10" size="small" type="info">
              暂存
            </el-tag>
            <el-tag v-if="row.status == 11" size="small" type="info">
              退款中
            </el-tag>
            <el-tag v-if="row.status == 12" size="small" type="info">
              已退款
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总税金" width="100">
          <template #default="{ row }">
            {{ row.tax_price }}
          </template>
        </el-table-column>
        <!-- 预报信息 -->
        <el-table-column align="center" prop="is_unclaimed" label="预报信息" width="100">
          <template #default="{ row }">
            <el-tag v-if="row.is_unclaimed == 0" size="mini" type="success">
              用户预报
            </el-tag>
            <el-tag v-if="row.is_unclaimed == 1" size="mini" type="warning">
              未认领
            </el-tag>
            <el-tag v-if="row.is_unclaimed == 2" size="mini" type="success">
              客服帮认领
            </el-tag>
          </template>
        </el-table-column>
        <!-- 订单金额 -->
        <el-table-column show-overflow-tooltip prop="price" label="订单金额"></el-table-column>
        <!-- 使用积分 -->
        <el-table-column show-overflow-tooltip prop="deduction_points" label="使用积分"></el-table-column>
        <!-- 退款金额 -->
        <el-table-column align="center" show-overflow-tooltip prop="refund_price" label="退款金额">
          <template #default="{ row }">
            <span v-if="row.status == 12">{{ row.refund_price }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- 订单重量 -->
        <el-table-column show-overflow-tooltip prop="weight" label="订单重量"></el-table-column>
        <!-- 打印状态 -->
        <el-table-column show-overflow-tooltip prop="print" label="打印状态" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.print == 0" size="mini" type="danger">
              未打印
            </el-tag>
            <el-tag v-if="row.print == 1" size="mini" type="success">
              已打印
            </el-tag>
          </template>
        </el-table-column>
        <!-- 打印次数 -->
        <el-table-column show-overflow-tooltip prop="yly_print" label="打印次数" align="center"></el-table-column>
        <!-- 订单发货方式 -->
        <el-table-column show-overflow-tooltip prop="shipping_type_name" label="发货方式" align="center"></el-table-column>
        <!-- 收件人 -->
        <el-table-column show-overflow-tooltip prop="name" label="收件人" align="center"></el-table-column>
        <!-- 手机号 -->
        <el-table-column show-overflow-tooltip prop="phone" label="手机号" width="110" align="center"></el-table-column>
        <!-- 备注 -->
        <el-table-column show-overflow-tooltip prop="remark2" label="备注" width="180" align="center"></el-table-column>
        <!-- 创建时间 -->
        <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" width="170" sortable
          align="center"></el-table-column>
        <el-table-column label="操作面板" width="350px" fixed="right" align="center">
          <template #default="{ row }">
            <!-- 客服 -->
            <el-button type="warning" icon="el-icon-headset" size="mini" @click="toKF(row)"></el-button>
            <el-button size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button type="primary" size="mini" @click="handledetails(row)">
              详情
            </el-button>
            <el-button type="danger" size="mini" @click="handleDelete(row)">
              删除
            </el-button>
            <el-button v-if="row.status == 11" type="warning" size="mini" @click="refund(row)">
              退款
            </el-button>
            <el-button v-if="row.status == 2" type="warning" size="mini" style="margin-top: 8px"
              @click="order_back(row)">
              订单退回
            </el-button>
            <el-button v-if="row.shipping_type == 7" type="warning" size="mini" style="margin-top: 8px"
              @click="mergeSplitReturn(row)">
              合箱分箱退回
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="isPhone" v-for="(item, index) in list" :key="index" class="list_item">
        <div class="order_code" style="margin-bottom: 5px;">{{ item.add_time }}</div>
        <div class="list_item_top" style="display: flex; align-items: center;">
          <span class="order_code" style="font-size: 14px; font-weight: 800;">订单编号：{{ item.old_kr_code }}</span>
          <span></span>
        </div>

        <div>
          <div class="list_itme_center">
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">用户昵称:</div>
              <div class="list_itme_span">{{ item.user_name }}({{ item.user_code }})</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">运单号:</div>
              <div class="list_itme_span">{{ item.express_code || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">包裹状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.status == 0" size="small" type="danger">
                  未入库
                </el-tag>
                <el-tag v-if="item.status == 1" size="small" type="success">
                  已入库
                </el-tag>
                <el-tag v-if="item.status == 2" size="small" type="warning">
                  待审核
                </el-tag>
                <el-tag v-if="item.status == 13" size="small" type="primary">
                  税金待支付
                </el-tag>
                <el-tag v-if="item.status == 3" size="small" class="dabaoStyle">
                  待打包
                </el-tag>
                <el-tag v-if="item.status == 4" size="small" class="fahuoStyle">
                  待发货
                </el-tag>
                <el-tag v-if="item.status == 5" size="small" type="warning">
                  待支付
                </el-tag>
                <el-tag v-if="item.status == 6" size="small" class="zhuanyunStyle">
                  转运中
                </el-tag>
                <el-tag v-if="item.status == 7" size="small" type="success">
                  已签收
                </el-tag>
                <el-tag v-if="item.status == 8" size="small" type="danger">
                  已拒绝
                </el-tag>
                <el-tag v-if="item.status == 10" size="small" type="info">
                  暂存
                </el-tag>
                <el-tag v-if="item.status == 11" size="small" type="info">
                  退款中
                </el-tag>
                <el-tag v-if="item.status == 12" size="small" type="info">
                  已退款
                </el-tag>
              </div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">订单金额:</div>
              <div class="list_itme_span">{{ item.price }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">使用积分:</div>
              <div class="list_itme_span">{{ item.deduction_points }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">退款金额:</div>
              <div class="list_itme_span">{{ item.refund_price || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">订单重量:</div>
              <div class="list_itme_span">{{ item.weight || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">打印状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.print == 0" size="mini" type="danger">
                  未打印
                </el-tag>
                <el-tag v-if="item.print == 1" size="mini" type="success">
                  已打印
                </el-tag>
              </div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">发货方式:</div>
              <div class="list_itme_span">{{ item.shipping_type_name || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">收件人:</div>
              <div class="list_itme_span">{{ item.name || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">手机号:</div>
              <div class="list_itme_span">{{ item.phone || '-' }}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">备注:</div>
              <div class="list_itme_span">{{ item.remark2 || '-' }}</div>
            </div>
            <div class="list_btn_box">
              <!-- 客服 -->
              <el-button type="warning" icon="el-icon-headset" size="mini" @click="toKF(item)"></el-button>
              <el-button size="mini" @click="handleEdit(item)">编辑</el-button>
              <el-button type="primary" size="mini" @click="handledetails(item)">
                详情
              </el-button>
              <el-button type="danger" size="mini" @click="handleDelete(item)">
                删除
              </el-button>
              <el-button v-if="item.status == 11" type="warning" size="mini" @click="refund(item)">
                退款
              </el-button>
              <el-button v-if="item.status == 2" type="warning" size="mini" @click="order_back(item)">
                订单退回
              </el-button>
              <el-button v-if="item.shipping_type == 7" type="warning" size="mini" @click="mergeSplitReturn(item)">
                合箱分箱退回
              </el-button>
            </div>
          </div>
        </div>
      </div>



      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
        :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
      <manage-parcel ref="edit" @fetch-data="getnewlist"></manage-parcel>
      <move-location ref="moveLocation" @change="doPrintMove"></move-location>
      <!-- 入库 -->
      <location-inbound ref="locationInbound" @change="doPrintMove"></location-inbound>
      <parcel-details ref="details" @fetch-data="getnewlist"></parcel-details>
      <tui-kuan ref="tuikuan" @change="getnewlist"></tui-kuan>
      <scan ref="scan" @change="scanlist" @changes="yulan"></scan>
      <cheng-scan ref="chengscan" @change="scanlist1"></cheng-scan>
    </div>
    <el-dialog title="面单尺寸" :visible.sync="mianDan_chiCun_show">
      <el-form>
        <el-form-item label="面单尺寸" :label-width="formLabelWidth">
          <el-select v-model="mianDan_chiCun_num" placeholder="请选择面单尺寸">
            <el-option label="100*150" :value="1"></el-option>
            <el-option label="100*180" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mianDan_chiCun_show = false">取 消</el-button>
        <el-button type="primary" @click="shure_size">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderList,
  goodsDel,
  orderStatus,
  orderNotice,
  oexcelOut,
  pullingCheck,
  orderDel,
  orderRefundRefund,
  orderYlyPrint,
  order_return,
  Order_excel_out_old,
  OrderExcel_import_excel,
  Returned_in_stock,
  OrderQuickClaimDetail,
  print_pick_list

} from '@/api/xgcApi'
import {
  Order_printStatus,
  Order_printCheck,
  check_order_print,
} from '@/api/print'
import manageParcel from '../components/manageParcel.vue'
import moveLocation from '../components/moveLocation'
import locationInbound from '../components/locationInbound'

import parcelDetails from '../components/parcelDetails'
import scan from '../components/scan.vue'
import chengScan from '../components/chengScan'
import tuiKuan from '../components/tuikuanK.vue'
import { baseURL_print, getUploadUrl } from '@/config'
import { number } from 'echarts'
import exoprt_file from '@/utils/expor_file' // 导出excel文件
export default {
  name: 'ComprehensiveTable',
  components: {
    manageParcel,
    parcelDetails,
    tuiKuan,
    scan,
    chengScan,
    moveLocation,
    locationInbound
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      name_type: null,
      formLabelWidth: '100px',
      mianDan_chiCun_show: false, //选择圆通面单尺寸
      mianDan_chiCun_num: 1, //打印的圆通面单的尺寸
      exportForm3Loading: false,
      height: '70vh', //表单高度
      isShowFahuo: false, //发货按钮
      isShowQianshou: false, //签收按钮
      isShowDabao: false, //打包按钮
      pullFormBtn: false, //拉单按钮
      doPrintLoading: false, //打印面单loading
      doPreviewLoading: false, //打印预览loading
      SFKdoPreviewLoading: false, //顺丰打印预览loading
      SFHdoPreviewLoading: false, //顺丰打印预览loading
      doSFHPrintLoading: false,
      printTaskId: 0, //打印相关
      printers: null, //打印相关
      chooseItem: [], //选中的数据
      chooseItem1: [], //选中的数据
      defaultPrinter: null, //打印相关
      waybillNO: '0000000000000', //打印相关
      waybillTemplateURL: baseURL_print + 'admin/index/print', //打印请求路径
      waybillTemplateURL1: baseURL_print + 'index/Cainiao/shipping_label', //打印请求路径
      socket: null, //打印相关
      list: [], //form的list
      imageList: [], //图片数组
      listLoading: true, //页面加载loading
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0, //数据条数
      background: true,
      selectRows: '', //多选
      elementLoadingText: '正在加载...', //页面加载文字展示
      queryForm: {
        page: 1,
        limit: 20,
        status: '',
        type: 1,
        print: null,
        shipping_type: '',
        start_time: '',
        end_time: '',
        time: "",
        kor_type: 0
      }, //请求的数据
      activeName: 'a', //表单切换初始化，显示全部
      remindCount: {}, //提示小红点数据
      sacnIds: [],
      options: [
        {
          value: 1,
          label: '已打印',
        },
        {
          value: 0,
          label: '未打印',
        },
      ],
      options1: [
        {
          value: 1,
          label: '原箱',
        },
        {
          value: 2,
          label: '套箱',
        },
        {
          value: 3,
          label: '分箱',
        },
        {
          value: 4,
          label: '合箱',
        },
        {
          value: 6,
          label: '换箱',
        },
        // {
        //   value: 7,
        //   label: '分箱后合箱',
        // },
      ],
      time: null,
      isPhone: false,
      resizeTimer: null, // 防抖定时器
    }
  },
  // computed: {
  //   height() {
  //     return this.$baseTableHeight()
  //   },
  // },
  created() {
    this.fetchData()
    this.checkIsPhone() // 改用这个方法
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.doConnect()
  },
  beforeDestroy() {
    this.destroy()
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }

  },
  methods: {
    // 时间选择器
    time_change(e) {
      if (e.length > 0) {
        this.queryForm.start_time = e[0]
        this.queryForm.end_time = e[1]
      } else {
        this.queryForm.start_time = null
        this.queryForm.end_time = null
      }
      this.getnewlist()
    },
    // 判断是否是手机
    checkIsPhone() {
      const isMobile = window.innerWidth < 768
      if (this.isPhone !== isMobile) {
        this.isPhone = isMobile
        // 切换时重新请求数据，刷新列表
        this.fetchData()
      }
    },
    // 防抖处理 resize
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      this.resizeTimer = setTimeout(() => {
        this.checkIsPhone()
      }, 300)
    },
    // 跳转客服链接
    toKF(row) {
      let uid = row.uid
      window.open(
        `https://call.youdaexpress.com/service?uid=${uid}&u_name=${row.user_name}`,
        '_blank', // 目标窗口：_blank(新标签)/_self(当前)/自定义名称
      );
    },
    // 销毁请求
    destroy() {
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
    },
    // 订单退回
    order_back(row) {
      this.$confirm('确认将此订单状态退回?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          var data = {
            order_id: row.id,
          }
          order_return(data).then((res) => {
            this.$message({
              type: 'success',
              message: '退回成功!',
            })
            this.fetchData()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    // 合箱分箱退回
    mergeSplitReturn(row) {
      this.$confirm('确认进行合箱分箱退回操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          var data = {
            order_id: row.id,
          }
          Returned_in_stock(data).then((res) => {
            this.$message({
              type: 'success',
              message: '退回成功!',
            })
            this.fetchData()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },

    // 打印包裹详情云打印
    // printDetail() {
    //   if (this.selectRows.length > 0) {
    //     this.$baseConfirm('确定打印已选', null, async () => {
    //       const ids = this.selectRows.map((item) => item.id).join()
    //       orderYlyPrint({
    //         id: ids,
    //       }).then((res) => {
    //         this.$message({
    //           type: 'success',
    //           message: '打印成功',
    //         })
    //       })
    //     })
    //   } else {
    //     this.$baseMessage('未选中任何行', 'warning')
    //     return false
    //   }
    // },
    yulan(data) {
      this.sacnIds = []
      this.chooseItem1 = data.list
      data.list.forEach((item, index) => {
        this.sacnIds.push(item.id)
      })
      this.doPreview1(data.pulling_type)
    },
    // table，切换方法
    handleClick(tab, event) {
      switch (tab.name) {
        case 'a':
          this.queryForm.status = ''
          this.pullFormBtn =
            this.isShowDabao =
            this.isShowFahuo =
            this.isShowQianshou =
            false
          this.destroy()
          break
        case 'b':
          this.queryForm.status = 0
          this.pullFormBtn = false
          this.isShowDabao = this.isShowQianshou = this.isShowFahuo = false
          this.destroy()
          break
        case 'c':
          this.queryForm.status = 1
          this.pullFormBtn = false
          this.isShowQianshou = true
          this.isShowDabao = this.isShowFahuo = false
          this.destroy()
          break
        case 'd':
          this.queryForm.status = 2
          this.pullFormBtn = this.isShowDabao = true
          this.isShowQianshou = this.isShowFahuo = false
          this.destroy()
          break
        case 'e':
          this.queryForm.status = 3
          this.pullFormBtn = this.isShowFahuo = true
          this.isShowDabao = this.isShowQianshou = false
          this.destroy()
          break
        case 'f':
          this.queryForm.status = 4
          this.pullFormBtn = true
          this.isShowDabao = this.isShowQianshou = this.isShowFahuo = false
          this.destroy()
          break
        case 'g':
          this.queryForm.status = 5
          this.pullFormBtn = true
          this.isShowDabao = this.isShowFahuo = this.isShowQianshou = false
          this.time = setInterval(() => {
            this.refreshPage()
          }, 1000)
          break
        case 'h':
          this.queryForm.status = 6
          this.pullFormBtn = this.isShowQianshou = true
          this.isShowDabao = this.isShowFahuo = false
          this.destroy()
          break
        case 'i':
          this.queryForm.status = 7
          this.pullFormBtn = true
          this.isShowDabao = this.isShowFahuo = this.isShowQianshou = false
          this.destroy()
          break
        case 'j':
          this.queryForm.status = 10
          this.pullFormBtn = true
          this.isShowDabao = this.isShowFahuo = this.isShowQianshou = false
          this.destroy()
          break
        case 'k':
          this.queryForm.status = 8
          this.isShowDabao = true
          this.isShowFahuo = this.isShowQianshou = this.pullFormBtn = false
          this.destroy()
          break
        case 'l':
          this.queryForm.status = 11
          this.isShowDabao =
            this.isShowFahuo =
            this.isShowQianshou =
            this.pullFormBtn =
            false
          this.destroy()
          break
        case 'm':
          this.queryForm.status = 12
          this.isShowDabao =
            this.isShowFahuo =
            this.isShowQianshou =
            this.pullFormBtn =
            false
          this.destroy()
          break
        case 'n':
          this.queryForm.status = 13
          this.pullFormBtn = false
          this.isShowDabao = this.isShowQianshou = this.isShowFahuo = false
          this.destroy()
          break
      }
      this.queryForm.page = 1
      this.fetchData()
    },
    // 请求列表数据
    getnewlist() {
      this.fetchData()
    },
    doPrintMove(data) {
      console.log(data, '打印数据')
      this.getPrintData5(data)
    },
    // 扫描单号成功返回
    scanlist(data) {
      this.sacnIds = []
      this.chooseItem1 = data
      data.forEach((item, index) => {
        this.sacnIds.push(item)
      })
      this.doPrint1(4)
    },
    // 称重机扫描打印
    scanlist1(data) {
      this.doPrint2(data)
    },
    // 列表图片查看
    tableSortChange() {
      const imageList = []
      this.$refs.tableSort.tableData.forEach((item, index) => {
        imageList.push(item.img)
      })
      this.imageList = imageList
    },
    // 多选
    setSelectRows(val) {
      this.selectRows = val
      this.chooseItem = val
    },
    // 添加，country=1韩国包裹添加
    handleAdd() {
      this.$refs['edit'].showEdit({
        country: 1,
      })
    },
    // 临时移动库位
    locaTionMove() {
      this.$refs['moveLocation'].showEdit()
    },
    packageLocationInbound() {
      this.$refs['locationInbound'].showEdit()

    },
    // 点击扫描包裹
    scanShow() {
      this.$refs['scan'].showEdit()
    },
    // 称重机扫描
    chengScanShow() {
      this.$refs['chengscan'].showEdit()
    },
    // 点击修改编辑
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },

    // 点击详情
    handledetails(row) {
      this.$refs['details'].showEdit(row)
    },

    // 点击退款
    refund(row) {
      // this.$prompt的message前面加必填标志 *
      this.$refs['tuikuan'].open(row, 1)
    },
// https://cloudprint.cainiao.com/template/standard/902505
    // 打印包裹详情本地打印
    printDetail() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定打印已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          OrderQuickClaimDetail({
            order_id: ids,
          }).then((res) => {
            this.getPrintData5(res.data)

          })
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
// 打印拣货单
 printPickingList() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定打印已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          print_pick_list({
            id: ids,
          }).then((res) => {
            this.getPrintData6(res.data)

          })
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },


  // 组装打印机需要的参数
    getPrintData6(printDetail) {
      var arrs = []
      printDetail.forEach((item, index) => {
        var dataArr = {
          documentID: this.waybillNO,
          contents: [
            //电子面单部分
            {
              templateURL:
                'https://cloudprint.cainiao.com/template/standard/902505',
              signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
              data: {
                user_code: item.user_code,
                old_kr_code: item.old_kr_code,
                storage_location: item.storage_location,
              },
              //电子面单数据
            },
          ],
        }
        arrs.push(dataArr)
      })
      var printData = this.SFgetPrintData(arrs)
      this.socket.send(JSON.stringify(printData))
    },



    // 组装打印机需要的参数
    getPrintData5(printDetail) {
      var arrs = []
      printDetail.forEach((item, index) => {
        var dataArr = {
          documentID: this.waybillNO,
          contents: [
            //电子面单部分
            {
              templateURL:
                'https://cloudprint.cainiao.com/template/standard/892119',
              signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
              data: {
                code: item.code,
                storage_location: item.storage_location,
                user_code: item.user_code,
                country: item.country,
                remark2: item.remark2,
              },
              //电子面单数据
            },
          ],
        }
        arrs.push(dataArr)
      })
      var printData = this.SFgetPrintData(arrs)
      this.socket.send(JSON.stringify(printData))
    },
    // 批量导出
    exportForm() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定导出已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          const { data } = await oexcelOut({
            id: ids,
          })
          const fileUrl = getUploadUrl + data
          window.open(fileUrl)
          this.$message({
            type: 'success',
            message: '导出成功',
          })
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    //条件导出
    async exportForm1() {
      const params = JSON.parse(JSON.stringify(this.queryForm))

      // 只在拷贝的对象上转换 shipping_type
      if (Array.isArray(params.shipping_type)) {
        params.shipping_type = params.shipping_type.join(',')
      }
      const { data } = await oexcelOut(params)
      const fileUrl = getUploadUrl + data
      window.open(fileUrl)
      this.$message({
        type: 'success',
        message: '导出成功',
      })
    },
    // 批量导出发货信息
    exportForm2() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定导出已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          const { data } = await Order_excel_out_old({
            id: ids,
          })
          const fileUrl = getUploadUrl + data
          window.open(fileUrl)
          this.$message({
            type: 'success',
            message: '导出成功',
          })
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 包裹导入完善
    exportForm3(file) {
      if (
        file.file.type ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.file.type == 'application/vnd.ms-excel'
      ) {
        file = file.file
        var data = {
          file: file,
        }
        this.exportForm3Loading = true
        var url = ''
        exoprt_file('/index/index/file', data)
          .then((res) => {
            var pic = res
            var date = {
              file: pic,
            }
            OrderExcel_import_excel(date)
              .then((res) => {
                this.$baseMessage('操作成功', 'success')
                this.fetchData()
                this.exportForm3Loading = false
              })
              .catch((err) => {
                this.exportForm3Loading = false
              })
          })
          .catch((err) => {
            this.exportForm3Loading = false
          })
        return
      } else {
        this.$baseMessage('请上传正确的文件', 'error')
        this.exportForm3Loading = false
      }
    },
    // 删除
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const { msg } = await orderDel({
            id: row.id,
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        if (this.selectRows.length > 0) {
          const ids = this.selectRows.map((item) => item.id).join()
          this.$baseConfirm('你确定要删除选中项吗', null, async () => {
            const { msg } = await orderDel({
              id: ids,
            })
            this.$baseMessage(msg, 'success')
            this.fetchData()
          })
        } else {
          this.$baseMessage('未选中任何行', 'warning')
          return false
        }
      }
    },

    // 批量打包。批量发货、批量签收、批量审核拒绝
    setQuery(e) {
      if (this.selectRows.length > 0) {
        if (e == 3) {
          this.$baseConfirm('确定通过已选', null, async () => {
            const ids = this.selectRows.map((item) => item.id).join()
            const { msg } = await orderStatus({
              order_id: ids,
              status: e,
            })
            this.$message({
              type: 'success',
              message: '审核成功',
            })
            this.fetchData()
          })
        }
        if (e == 4) {
          this.$baseConfirm('确定发货已选', null, async () => {
            const ids = this.selectRows.map((item) => item.id).join()
            const { msg } = await orderStatus({
              order_id: ids,
              status: e,
            })
            this.$message({
              type: 'success',
              message: '发货成功',
            })
            this.fetchData()
          })
        }
        if (e == 7) {
          this.$baseConfirm('确定签收已选', null, async () => {
            const ids = this.selectRows.map((item) => item.id).join()
            const { msg } = await orderStatus({
              order_id: ids,
              status: e,
            })
            this.$message({
              type: 'success',
              message: '签收成功',
            })
            this.fetchData()
          })
        }
        if (e == 8) {
          this.$baseConfirm('确定拒绝已选', null, async () => {
            const ids = this.selectRows.map((item) => item.id).join()
            const { msg } = await orderStatus({
              order_id: ids,
              status: e,
            })
            this.$message({
              type: 'success',
              message: '操作成功',
            })
            this.fetchData()
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 批量拉单
    pullForm(e) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('你确定要拉取选中项吗', null, async () => {
          const { data, code } = await pullingCheck({
            id: ids,
            type: e,
          })
          if (code == 200) {
            const { msg } = await orderNotice({
              id: ids,
              type: e,
            })

            this.$baseMessage(msg, 'success')
          } else {
            this.$baseMessage(msg, 'error')
          }
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    // 分页
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    // 查询
    handleQuery() {
      this.queryForm.page = 1
      this.fetchData()
    },
    // 请求列表数据，type=1，韩国包裹
    async fetchData() {
      this.listLoading = true
      const params = JSON.parse(JSON.stringify(this.queryForm))

      // 只在拷贝的对象上转换 shipping_type
      if (Array.isArray(params.shipping_type)) {
        params.shipping_type = params.shipping_type.join(',')
      }
      // this.doConnect()
      const { data } = await orderList(params)
      this.list = data.list
      this.remindCount = data.statusCount
      this.total = data.count
      const imageList = []
      data.list.forEach((item, index) => {
        imageList.push(item.pic)
      })

      this.imageList = imageList

      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },
    // 刷新数据
    async refreshPage() {
      const { data } = await orderList(this.queryForm)
      this.list = data.list
      this.remindCount = data.statusCount
      this.total = data.count
      const imageList = []
      data.list.forEach((item, index) => {
        imageList.push(item.pic)
      })
      this.imageList = imageList
    },

    /**
     * @name wqz
     * @function 面单打印相关方法
     * @time 2024年4月18日09:32:42
     */
    doConnect() {
      var that = this
      this.socket = new WebSocket('ws://127.0.0.1:13528')
      var result = '打印成功'
      var tmptaskID = '0'
      var that = this
      // 打开Socket
      that.socket.onopen = function (event) {
        // 监听消息
        that.socket.onmessage = function (event) {
          var data = JSON.parse(event.data)
          that.printers = data.printers
          that.defaultPrinter = data.defaultPrinter
          if (data.cmd == 'notifyPrintResult') {
            // 打印出现问题
            var result = '打印成功'
            if (data.taskID != tmptaskID) {
              for (var i = 0; i < data.printStatus.length; i++) {
                if (data.printStatus[i].status == 'failed') {
                  result = '打印失败'
                  that.$message({
                    type: 'error',
                    message: '打印失败',
                  })
                  break
                } else if (data.printStatus[i].status == 'canceled') {
                  that.$message({
                    type: 'error',
                    message: '取消打印任务',
                  })
                  result = '取消打印任务'
                  break
                }
              }
              tmptaskID = data.taskID
            }
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFKdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
          } else if (data.cmd == 'print') {
            // 这里面写打印/预览成功之后的回调
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFKdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
            if (data.previewURL) {
              // 预览成功打开pdf文件url
              window.open(data.previewURL)
            } else {
              // 打印成功
              // var date =this.chooseItem
              var ids = []
              that.chooseItem.forEach((item, index) => {
                ids.push(item.id)
              })
              var date = {
                id: ids.join(','),
              }
              if (data.status != 'success') {
                that.$message({
                  type: 'error',
                  message: data.msg,
                })
              } else {
                Order_printStatus(date).then((res) => {
                  // 这个是打印成功回调
                  that.$message({
                    type: 'success',
                    message: '打印成功',
                  })
                })
              }
            }
          }
        }
        // 监听Socket的关闭
        that.socket.onclose = function (event) {
          that.$message({
            type: 'error',
            message: '打印机失去联系，请刷新网页重新连接',
          })
        }
      }
      that.socket.onerror = function (event) {
        that.$message({
          type: 'error',
          message: '打印机出现问题,请联系客服',
        })
      }
    },
    // 圆通打印/预览 选择尺寸弹出层
    get_size(type, name) {
      // type 0打印 1预览
      this.yt_type = type
      this.name_type = name
      this.mianDan_chiCun_show = true
    },
    shure_size() {
      // 确认圆通面单打印尺寸
      if (this.name_type == 'YT') {
        if (this.yt_type == 0) {
          // 0打印
          this.doPrint('YT')
        } else {
          // 预览
          this.doPreview('YT')
        }
      }
      if (this.name_type == 'SFH') {
        if (this.yt_type == 0) {
          // 0打印
          this.doPrint('SFH')
        } else {
          // 预览
          this.doPreview('SFH')
        }
      }
      if (this.name_type == 'SFK') {
        if (this.yt_type == 0) {
          // 0打印
          this.doPrint('SFK')
        } else {
          // 预览
          this.doPreview('SFK')
        }
      }

      this.mianDan_chiCun_show = false
    },
    // 打印预览
    doPreview(type) {
      if (this.selectRows.length > 0) {
        if (type == 'YT') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              printData.task.preview = true
              this.doPreviewLoading = true

              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          // 顺丰空运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰空运面单
            console.log('150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            // 180尺寸 顺丰空运面单
            console.log('180尺寸 顺丰海运面单')
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    // templateURL: 'https://cloudprint.cainiao.com/template/standard/771230/16',
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          // 顺丰海运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            // if (item.pulling_type == 4) {
            ids.push(item.id)
            // }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('预览 150尺寸 顺丰海运面单')
            // urls = 'https://cloudprint.cainiao.com/template/standard/877264'
            urls = 'https://cloudprint.cainiao.com/template/standard/899425'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('预览 180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }

          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名`备注:${item.remark2}`, //备注 
                      note: item.remark2, //物品名
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.express_code, //二维码
                      now: item.add_time, //时间
                      shippingTypeName: item.shipping_type_name //完善方式
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 打印预览
    doPreview1(type) {
      if (type == '1') {
        var data = {
          id: this.sacnIds,
        }
        Order_printCheck(data).then((res) => {
          var printData = this.getPrintData1()
          printData.task.preview = true
          this.doPreviewLoading = true
          this.socket.send(JSON.stringify(printData))
        })
      }
      if (type == '3') {
        var data = {
          id: this.sacnIds,
        }
        // 验证接口
        Order_printCheck(data).then((res) => {
          var arrs = []
          var from = {}
          from = res.data.from
          res.data.list.forEach((item, index) => {
            const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
            var dataArr = {
              documentID: this.waybillNO,
              contents: [
                {
                  templateURL:
                    'https://cloudprint.cainiao.com/template/standard/771230/16',
                  signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                  data: {
                    orderNo: item.code, //订单号
                    logisticsNo: item.express_code, //运单号
                    shortAddress: item.pulling.mark, // 三段码
                    packageCenterName: item.packageCenterName, //
                    consignee: item.name, //收件人
                    consigneeTel: item.phone, //收件人联系方式
                    consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                    consigner: from.username, //发件人
                    consignerTel: from.mobile, //发件人电话
                    consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                    goodsInfo: goodsInfo, //物品名
                    note: item.remark2, //备注
                    logisticsMark: '', // 没用
                    twoDimensionCode: item.pulling.two_dimension_code, //二维码
                    now: item.add_time, //时间
                  },
                },
              ],
            }
            arrs.push(dataArr)
          })
          var printData = this.SFgetPrintData(arrs)
          printData.task.preview = true
          this.SFdoPreviewLoading = true
          this.socket.send(JSON.stringify(printData))
        })
      }
    },
    // 称重机打印面单
    doPrint2(e) {
      var data = {
        code: e,
      }
      check_order_print(data).then((res) => {
        var printData = this.getPrintData2(res.data)
        this.doPreviewLoading = true
        this.socket.send(JSON.stringify(printData))
      })
    },
    //打印电子面单
    doPrint1(type) {
      if (type == '1') {
        // 圆通面单打印
        var data = {
          id: this.sacnIds,
        }
        Order_printCheck(data).then((res) => {
          var printData = this.getPrintData1()
          this.doPreviewLoading = true
          this.socket.send(JSON.stringify(printData))
        })
      }
      if (type == '3') {
        // 顺丰面单打印
        var data = {
          id: this.sacnIds,
        }
        // 验证接口
        Order_printCheck(data).then((res) => {
          var arrs = []
          var from = {}
          from = res.data.from
          res.data.list.forEach((item, index) => {
            const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
            var dataArr = {
              documentID: this.waybillNO,
              contents: [
                {
                  templateURL:
                    'https://cloudprint.cainiao.com/template/standard/771230/12',
                  signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                  data: {
                    orderNo: item.code, //订单号
                    logisticsNo: item.express_code, //运单号
                    shortAddress: item.pulling.mark, // 三段码
                    packageCenterName: item.packageCenterName, //
                    consignee: item.name, //收件人
                    consigneeTel: item.phone, //收件人联系方式
                    consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                    consigner: from.username, //发件人
                    consignerTel: from.mobile, //发件人电话
                    consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                    goodsInfo: goodsInfo,// item.brand.brand_type_name ? item.brand.brand_type_name : '', //物品名
                    note: item.remark2, //备注
                    logisticsMark: '', // 没用
                    twoDimensionCode: item.pulling.two_dimension_code, //二维码
                    now: item.add_time, //时间
                  },
                },
              ],
            }
            arrs.push(dataArr)
          })
          var printData = this.SFgetPrintData(arrs)
          this.SFdoPreviewLoading = true
          this.socket.send(JSON.stringify(printData))
        })
      }
      if (type == '4') {
        // 顺丰海运面单打印
        var data = {
          id: this.sacnIds,
        }
        // 验证接口
        Order_printCheck(data).then((res) => {
          var arrs = []
          var from = {}
          from = res.data.from
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('150尺寸 顺丰海运面单')
            // urls = 'https://cloudprint.cainiao.com/template/standard/877264'
            urls = 'https://cloudprint.cainiao.com/template/standard/899425'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }
          res.data.list.forEach((item, index) => {
            let result = ''
            if (item.brand && item.brand.length > 0) {
              // 合并相同名称
              const merged = item.brand.reduce((acc, t) => {
                const key = t.brand_type_name;
                acc[key] = (acc[key] || 0) + t.num;
                return acc;
              }, {});
              // 直接拼接成字符串
              result = Object.entries(merged)
                .map(([name, num]) => `${name} * ${num}`)
                .join(" , ");
            }
            var dataArr = {
              documentID: this.waybillNO,
              contents: [
                {
                  templateURL: urls,
                  signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                  data: {
                    orderNo: item.code, //订单号
                    logisticsNo: item.express_code, //运单号
                    shortAddress: item.pulling.mark, // 三段码
                    packageCenterName: item.packageCenterName, //
                    consignee: item.name, //收件人
                    consigneeTel: item.phone, //收件人联系方式
                    consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                    consigner: from.username, //发件人
                    consignerTel: from.mobile, //发件人电话
                    consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                    goodsInfo: result,//`备注:${item.remark2}`, //物品名
                    note: item.remark2, //备注
                    logisticsMark: '', // 没用
                    twoDimensionCode: item.express_code, //二维码
                    now: item.add_time, //时间
                    shippingTypeName: item.shipping_type_name //完善方式
                  },
                },
              ],
            }
            arrs.push(dataArr)
          })
          var printData = this.SFgetPrintData(arrs)
          this.SFHdoPreviewLoading = true
          this.socket.send(JSON.stringify(printData))
        })
      }
    },
    //打印电子面单
    doPrint(type) {
      if (this.selectRows.length > 0) {
        // const ids = this.selectRows.map((item) => item.id).join()
        // this.$baseConfirm('你确定打印选中项吗', null, async () => {
        //   var data = {
        //     id: ids,
        //   }
        //   Order_printCheck(data).then((res) => {
        //     var printData = this.getPrintData()
        //     this.doPrintLoading = true
        //     this.socket.send(JSON.stringify(printData))
        //   })
        // })
        if (type == 'YT') {
          // 圓通面單打印
          // var ids = this.selectRows.map((item) => item.id).join(',')
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              this.doPreviewLoading = true
              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          // 顺丰空运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰空运面单
            console.log('150尺寸 顺丰空运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            // 180尺寸 顺丰空运面单
            console.log('180尺寸 顺丰空运面单')
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    // templateURL: 'https://cloudprint.cainiao.com/template/standard/771230/16',
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          // 顺丰海运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            // if (item.pulling_type == 4) {
            ids.push(item.id)
            // }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/899425'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from

            res.data.list.forEach((item, index) => {
              let result = ''
              if (item.brand && item.brand.length > 0) {
                // 合并相同名称
                const merged = item.brand.reduce((acc, t) => {
                  const key = t.brand_type_name;
                  acc[key] = (acc[key] || 0) + t.num;
                  return acc;
                }, {});
                // 直接拼接成字符串
                result = Object.entries(merged)
                  .map(([name, num]) => `${name} * ${num}`)
                  .join(" , ");
              }
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: result,// `备注:${item.remark2}`, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.express_code, //二维码
                      now: item.add_time, //时间
                      shippingTypeName: item.shipping_type_name //wanshang
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 组装打印机需要的参数
    getPrintData() {
      var dataArr = []
      this.chooseItem.forEach((item, ind) => {
        if (item.pulling_type == 1) {
          dataArr.push({
            documentID: this.waybillNO,
            contents: [
              //电子面单部分
              {
                // templateURL: this.waybillTemplateURL + '?id=' + item.id,
                templateURL: `${this.waybillTemplateURL}?id=${item.id}&type=${this.mianDan_chiCun_num}`,
                signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                //电子面单数据
              },
            ],
          })
        }
      })
      if (dataArr.length <= 0) {
        this.$message({
          type: 'warning',
          message: '没有可打印的圆通面单',
        })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: dataArr,
        },
      }
      return request
    },
    // 称重机打印
    getPrintData2(e) {
      var dataArr = []
      dataArr.push({
        documentID: this.waybillNO,
        contents: [
          //电子面单部分
          {
            templateURL: this.waybillTemplateURL1 + '?id=' + e.id,
            signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
            //电子面单数据
          },
        ],
      })

      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: dataArr,
        },
      }
      return request
    },
    getPrintData1() {
      var dataArr = []
      this.chooseItem1.forEach((item, ind) => {
        dataArr.push({
          documentID: this.waybillNO,
          contents: [
            //电子面单部分
            {
              templateURL: this.waybillTemplateURL + '?id=' + item,
              signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
              //电子面单数据
            },
          ],
        })
      })

      if (dataArr.length <= 0) {
        this.$message({
          type: 'warning',
          message: '没有可打印的圆通面单',
        })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: dataArr,
        },
      }
      return request
    },
    SFgetPrintData(arrs) {
      var dataArr = []
      if (arrs.length <= 0) {
        this.$message({
          type: 'warning',
          message: '没有可打印的顺丰面单',
        })
        return
      }
      this.printTaskId = parseInt(Date.now().toString() + Math.floor(Math.random() * 1000).toString().padStart(3, '0'))
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: arrs,
        },
      }
      return request
    },
  },
}
</script>

<style scoped>
:deep .el-button--mini {
  padding: 5px 11px;
}

:deep .right-panel {
  display: flex;
  align-items: center;
}

.demo-tabs .custom-tabs-label span {
  vertical-align: super;
  margin-left: 4px;
}

::v-deep(.el-badge__content.is-fixed) {
  top: 11px;
  right: 17px;
}

.table-container {
  padding: 15px;
  /* padding-top: 30px; */
  box-sizing: border-box;
  /* border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed; */
}

.el-tabs__item {
  width: 200px;
  /* 设置宽度为200px */
}

.el-badge {
  width: 60px !important;
}

::v-deep(.el-tabs__header) {
  margin: 0 !important;
}

::v-deep(.el-tabs__header span) {
  font-weight: bold;
}

.demo-table-expand {
  font-size: 0;
  padding-left: 150px;
  box-sizing: border-box;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
}

.dabaoStyle {
  background: #ffddaa;
  color: #999;
  border: 1px solid #fd5;
}

.fahuoStyle {
  background: #99dddd;
  color: #999;
  border: 1px solid 00FFFF;
}

.zhuanyunStyle {
  background: #ffffaa;
  color: #999;
  border: 1px solid FFFF00;
}

/* 新增手机版样式 */
.list_item {
  border-bottom: 1px solid #f2f2f2;
  border-top: 1px solid #f2f2f2;
  padding: 8px 12px;
  box-sizing: border-box;
}

.list_item_top {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.order_code {
  font-size: 12px;
  color: #aaa;
}

.list_itme_center {
  display: flex;
  flex-direction: column;
}

.list_itme_center_title {
  font-size: 14px;
  color: #aaa;
  margin-right: 8px;
  width: 20%;
}

.list_itme_span {
  font-size: 14px;
  color: #333;
}

.list_itme_span_th {
  margin-top: 10px;
  display: flex;
}

.list_btn_box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.pop_item {
  border: 2px solid #f2f2f2;
  padding: 12px 0;
  margin-bottom: 16px;
  border-radius: 15px;
  padding: 8px;
}

.list_itme_pop_titl {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pop_ite_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
